export default __webpack_public_path__ + "static/media/scale_atlas.5f4bd4e7.mp3";